import Vue from 'vue';
import '@/authInterceptor';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faListUl, faListAlt, faSync, faUser, faExclamationTriangle, faPlusCircle,
  faCalendarAlt, faPlusSquare, faMinusSquare, faArrowUp, faEdit, faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// @ts-ignore
import iView from 'iview';
// @ts-ignore
import locale from 'iview/src/locale/lang/en-US';
import AccountCore from '@/views/AccountCore.vue';
import AccountProduct from '@/views/AccountProduct.vue';
import FileMover from '@/views/FileMover.vue';
import MulesoftFi from '@/views/MulesoftFi.vue';
import PaymentProcessor from '@/views/PaymentProcessor.vue';
import MulesoftCore from '@/views/MulesoftCore.vue';
import GhostLoan from '@/views/GhostLoan.vue';
import NxtsofFi from '@/views/NxtsofFi.vue';
import CldLoanImporter from '@/views/CldLoanImporter.vue';
import GenericWhitelist from '@/views/GenericWhitelist.vue';
import MeridianLink from '@/views/MeridianLink.vue';
import '@/plugins/axios';
import '@/plugins/vuetify';
import App from '@/App.vue';
import store from '@/store';
import router from './router';
import 'iview/dist/styles/iview.css';

library.add(faListUl);
library.add(faListAlt);
library.add(faSync);
library.add(faUser);
library.add(faExclamationTriangle);
library.add(faPlusCircle);
library.add(faCalendarAlt);
library.add(faPlusSquare);
library.add(faMinusSquare);
library.add(faArrowUp);
library.add(faEdit);
library.add(faTrashAlt);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;
Vue.use(iView, { locale });

// handle page reloads
const app: Vue = new Vue({
  el: '#app',
  store,
  router,
  components: {
    AccountCore,
    AccountProduct,
    GenericWhitelist,
    FileMover,
    MulesoftFi,
    MulesoftCore,
    GhostLoan,
    NxtsofFi,
    PaymentProcessor,
    CldLoanImporter,
    MeridianLink,
  },
  render: h => h(App),
});
